export default class CkeditorUploadAdapter {
  constructor(loader, apiUrl, oneTimeToken) {
    this.loader = loader;
    this.apiUrl = apiUrl;
    this.oneTimeToken = oneTimeToken;
  }

  upload() {
    this.abortController = new AbortController();
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          this._fetchRequest(file, resolve, reject);
        })
    );
  }

  _fetchRequest(file, resolve, reject) {
    const filename = file.name;
    this.data = new FormData();
    const operations = {
      variables: {
        file: null,
      },
      query: 'mutation($file: Upload!) { adminUploadAttachment(file: $file) { url }}',
    };
    const maps = {
      upload: ['variables.file'],
    };

    const jsonOperations = JSON.stringify(operations);
    const jsonMaps = JSON.stringify(maps);

    this.data.append('operations', jsonOperations.replace(/\s/g, ''));
    this.data.append('map', jsonMaps.replace(/\s/g, ''));

    this.data.append('upload', file, filename);

    fetch(this.apiUrl, {
      signal: this.abortController.signal,
      method: 'POST',
      headers: {
        Authorization: this.oneTimeToken,
      },
      body: this.data,
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        if (json.errors && json.errors.length > 0) {
          return reject(`An error occured during upload: ${json?.errors?.[0]?.message}`);
        }
        const { url } = json.data?.adminUploadAttachment || '';
        resolve({ default: url });
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          return reject();
        }

        return reject(`An error occured during uploading file ${error}`);
      });
  }
}
